// Funkce pro přesunutí obrazovky  >>
function scrollWin(el, time, editPos) {
    var time = time ? time : 1000,
        finalPos = $(el).offset().top;
    if (editPos) finalPos += editPos;

    $('body, html').stop().animate({
        scrollTop: finalPos
    }, time);
}